import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { CUSTOMER_ACTIVITIES_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getCustomerActivitiesAction = createAsyncThunk(
    'customer/getCustomerActivitiesAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ CUSTOMER_ACTIVITIES_PATH }/${ data.id }${ buildQueryString(data.queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCustomerActivitiesSlice = createSlice({
    name: 'getCustomerActivitiesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCustomerActivitiesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCustomerActivitiesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCustomerActivitiesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getCustomerActivitiesState = (state) => state.customer.getCustomerActivities;
export default getCustomerActivitiesSlice.reducer;